import { Center } from '../../lib/types/models/center/center'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripFolderCenters(id: number) {
  return restApiClient.url(constructApiUrl(API.tripFolder.getCenters.url, { id })).get<Center[]>()
}
